// ─── SEO por página ───────────────────────────────────────────────
// Helper client-side que atualiza <title>, meta description, keywords,
// canonical e as tags Open Graph / Twitter Card ao montar cada página.
// O Google renderiza o JS e usa esses valores por rota. Os padrões
// estáticos (para scrapers que não executam JS, ex.: WhatsApp) ficam
// em public/index.html.

export const SITE_URL = "https://imobmeet.com.br";
export const DEFAULT_OG_IMAGE = SITE_URL + "/og-image.jpg";

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * @param {object} o
 * @param {string} o.title        Título da aba / SEO title
 * @param {string} o.description  Meta description
 * @param {string} [o.keywords]   Palavras-chave (Yoast-style)
 * @param {string} [o.path]       Caminho da rota (ex.: "/crm-loteadoras")
 * @param {string} [o.image]      URL absoluta da imagem OG (default: card da marca)
 */
export function applySeo({ title, description, keywords, path = "/", image = DEFAULT_OG_IMAGE }) {
  const url = SITE_URL + path;

  if (title) document.title = title;
  setMeta("name", "description", description);
  if (keywords) setMeta("name", "keywords", keywords);
  setLink("canonical", url);

  // Open Graph (Facebook, WhatsApp, LinkedIn)
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("property", "og:image", image);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:site_name", "IMOBMEET");
  setMeta("property", "og:locale", "pt_BR");

  // Twitter Card
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
}
